import { render, staticRenderFns } from "./EditFormComponent.vue?vue&type=template&id=2e5fb072&scoped=true&"
import script from "./EditFormComponent.vue?vue&type=script&lang=js&"
export * from "./EditFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditFormComponent.vue?vue&type=style&index=0&id=2e5fb072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5fb072",
  null
  
)

export default component.exports